<template>
<div>
	<div class="d-flex flex-row flex-wrap">

		<label class="mr-3">
			<input type="checkbox" :value="true" v-model="reviewedTilesVisible">
			Show reviewed tiles
		</label>

		<label class="mr-3">
			<input type="checkbox" :value="true" v-model="allJobsVisible" v-on:change="toggleJobShowState">
			Show all unsubmitted logs
		</label>
	</div>
	<section v-if="localPayPeriod" v-for="(job, jobIndex) in localPayPeriod.jobs">
		
		<div v-if="job.noReviewManager" class="alert alert-warning float-right">
			<i class="fa fa-exclamation-triangle"></i>
			This project does not have a time log reviewer assigned.
		</div>
		<div v-else-if="!job.reviewable" class="alert alert-info float-right">
			<i class="fa fa-lock"></i> 
			This project is managed by another Employee, so you don't need to review it, but it is viewable here for reference.
		</div>

		<h3>
			<router-link v-if="job.type == 'project'" :to="'/project/'+job.slug+'/dashboard'">{{job.job_num}}: {{job.job_name}}</router-link>

			<router-link v-else :to="'/service/'+job.slug+'/dashboard'">{{job.job_num}}: {{ job.job_name }}<br><small>{{job.customerName}}</small></router-link>
		</h3>

		<div v-if="job.pays_perdiem == 1 || job.pays_mileage == 1" class="alert alert-info">
			<i class="fa fa-info"></i>
			This job is set to pay: &nbsp;
			<template v-if="job.pays_mileage == 1">
				<i class="fa fa-car"></i><strong> Mileage</strong>
			</template>
			<span v-if="job.pays_perdiem == 1 && job.pays_mileage == 1">, </span>
			<template v-if="job.pays_perdiem == 1">
				<i class="fa fa-spoon"></i>
				<strong> Per diem</strong>
			</template>
		</div>
		<div style="clear: both;"></div>

		<div style="overflow-x: auto;">

			<table v-if="job.users.length > 0" class="table table-sm" style="margin-left: -0.6px;margin-bottom: 0">
				<thead>
					<th>Employee</th>
					<th v-for="day in job.users[0].days">{{day.label}}</th>
					<th>Totals/Notes</th>
				</thead>
				<tbody>
					<template v-for="(user,userIndex) in job.users">
						<tr>
							<td style="position: relative;">

								<div class="mb-auto">{{ user.fullName }}</div>
								<div class="text-muted ">{{ user.unionName }}</div>

								<button  
									v-if="!user.showLogsList"
									class="btn btn-sm btn-light mb-1"
									v-on:click="toggleUserLogsPanel(user)">
									View All Logs...
								</button>
							</td>
							<td v-for="day in user.days" >
								<time-log-review-tile
									v-if="reviewedTilesVisible || (!reviewedTilesVisible && dayLog.reviewed_by == 0)"
									v-for="dayLog in day.logs"
									:key="dayLog.id"
									:day-log="dayLog"
									:job="job"
									:log-has-pending-transfers="logHasPendingTransfers(dayLog)"
									v-on:edit="editTimeLog(dayLog,job)">
								</time-log-review-tile>
							</td>
							<td>

								<table v-if="allJobsVisible" class="nested-table-plain text-right table-vertical-borders" style="font-size: 10pt;">
									<tr>
										<th></th>
										<th>{{ job.job_num }}</th>
										<th>Other</th>
										<th>Total</th>
									</tr>
									<tr v-if="user.totals.regular_hours > 0 || user.totals.otherJobs.regular_hours > 0">
										<th>Reg</th>
										<td>{{user.totals.regular_hours.toFixed(2)}}</td>
										<td>{{user.totals.otherJobs.regular_hours.toFixed(2)}}</td>
										<td>{{user.totals.allJobs.regular_hours.toFixed(2)}}</td>
									</tr>
									<tr v-if="user.totals.overtime_hours_15x > 0 || user.totals.otherJobs.overtime_hours_15x > 0">
										<th>OT 1.5x</th>
										<td>{{user.totals.overtime_hours_15x.toFixed(2)}}</td>
										<td>{{user.totals.otherJobs.overtime_hours_15x.toFixed(2)}}</td>
										<td>{{user.totals.allJobs.overtime_hours_15x.toFixed(2)}}</td>
									</tr>
									<tr v-if="user.totals.overtime_hours_2x > 0 || user.totals.otherJobs.overtime_hours_2x > 0">
										<th>OT 2x</th>
										<td>{{user.totals.overtime_hours_2x.toFixed(2)}}</td>
										<td>{{user.totals.otherJobs.overtime_hours_2x.toFixed(2)}}</td>
										<td>{{user.totals.allJobs.overtime_hours_2x.toFixed(2)}}</td>
									</tr>
									<tr v-if="user.totals.overtime_hours_25x > 0 || user.totals.otherJobs.overtime_hours_25x > 0">
										<th>OT 2.5x</th>
										<td>{{user.totals.overtime_hours_25x.toFixed(2)}}</td>
										<td>{{user.totals.otherJobs.overtime_hours_25x.toFixed(2)}}</td>
										<td>{{user.totals.allJobs.overtime_hours_25x.toFixed(2)}}</td>
									</tr>
									<tr>
										<th>Period Total</th>
										<th>{{user.totals.total.toFixed(2)}}</th>
										<th>{{user.totals.otherJobs.total.toFixed(2)}}</th>
										<th>{{user.totals.allJobs.total.toFixed(2)}}</th>
									</tr>
								</table>
								<div v-else>
									<table class="nested-table-plain text-right table-vertical-borders" style="font-size: 10pt;">
										<tr>
											<th></th>
											<th>{{ job.job_num }}</th>
										</tr>
										<tr v-if="user.totals.regular_hours > 0">
											<th>Reg</th>
											<td>{{user.totals.regular_hours.toFixed(2)}}</td>
										</tr>
										<tr v-if="user.totals.overtime_hours_15x > 0">
											<th>OT 1.5x</th>
											<td>{{user.totals.overtime_hours_15x.toFixed(2)}}</td>
										</tr>
										<tr v-if="user.totals.overtime_hours_2x > 0">
											<th>OT 2x</th>
											<td>{{user.totals.overtime_hours_2x.toFixed(2)}}</td>
										</tr>
										<tr v-if="user.totals.overtime_hours_25x > 0">
											<th>OT 2.5x</th>
											<td>{{user.totals.overtime_hours_25x.toFixed(2)}}</td>
										</tr>
										<tr>
											<th>Period Total</th>
											<th>{{user.totals.total.toFixed(2)}}</th>
										</tr>
									</table>
									<p class="text-muted"><small><a href="#" v-on:click.prevent="showAllJobs">Show all unsubmitted logs for a more comprehensive summary</a></small></p>
								</div>

								<field 
									v-if="typeof approvedLogSet[jobIndex] != 'undefined' && approvedLogSet.length > 0 && job.reviewable" 
									:value="allLogsApproved(user)" 
									:params="{type: 'boolean'}" 
									label="Toggle All" 
									col-class="stacked" 
									v-on:change="userLogSetReviewChanged(jobIndex,userIndex,user)">
								</field>

								<div v-if="allUserJobLogsApproved(user)" class="alert alert-success text-center row-all-approved">
									<i class="fa fa-2x fa-check"></i>
								</div> 

							</td>
						</tr>
						<tr v-if="user.showLogsList">
							<td>
								<i class="fa fa-times icon-button close-button" v-on:click="toggleUserLogsPanel(user)"></i>
							</td>
							<td :colspan="user.days.length + 1">
								<table-list
									:key="user.fullName"
									:records="mutateUserLogs(user.id)"
									:fields="userLogsFields"
									record-name="Time Log"
									:has-edit="false"
									id-field="slug">
								</table-list>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>
		<hr>
	</section>

	<modal-dialog
		v-if="transferNoticeModal.transferRequest.RequestedBy"
		:modal-visible="transferNoticeModal.visible"
		title="Overtime Transfer Request"
		confirm-button-text="Submit"
		v-on:closeModal="transferNoticeModal.visible=false"
		v-on:confirm="submitTransferRequest"
		>

		<p>{{transferNoticeModal.transferRequest.RequestedBy.first_name}} {{transferNoticeModal.transferRequest.RequestedBy.last_name}} wants to transfer the following overtime hours to this log:</p>

		<ul>
			<li v-if="transferNoticeModal.transferRequest.overtime_15x > 0"><strong>1.5x OT Hrs:</strong> {{ transferNoticeModal.transferRequest.overtime_15x }}</li>
			<li v-if="transferNoticeModal.transferRequest.overtime_2x > 0"><strong>2x OT Hrs:</strong> {{ transferNoticeModal.transferRequest.overtime_2x }}</li>
			<li v-if="transferNoticeModal.transferRequest.overtime_25x > 0"><strong>2.5x OT Hrs:</strong> {{ transferNoticeModal.transferRequest.overtime_25x }}</li>
		</ul>

		<field label="Approve/Deny" col-class="col-md-4" :params="{type: 'btn-group',buttons:[
			{text: 'Approve',value:true,icon: 'fa-check'},{text: 'Deny',value:false, icon: 'fa-times'}
		]}" v-model="transferNoticeModal.response"></field>

		<table class="table">
			<thead>
				<tr>
					<th></th>
					<th class="text-right">Current State</th>
					<th class="text-right">After Transfer</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th>Regular Hours</th>
					<td class="text-right">{{ transferNoticeModal.log.regular_hours }}</td>
					<td class="text-right">{{ transferNoticeModal.projectedLog.regular_hours.toFixed(2) }}</td>
				</tr>
				<tr v-if="transferNoticeModal.log.overtime_hours_15x > 0 || transferNoticeModal.projectedLog.overtime_hours_15x > 0">
					<th>1.5x Overtime</th>
					<td class="text-right">{{ transferNoticeModal.log.overtime_hours_15x }}</td>
					<td class="text-right">{{ transferNoticeModal.projectedLog.overtime_hours_15x.toFixed(2) }}</td>
				</tr>
				<tr v-if="transferNoticeModal.log.overtime_hours_2x > 0 || transferNoticeModal.projectedLog.overtime_hours_2x > 0">
					<th>2x Overtime</th>
					<td class="text-right">{{ transferNoticeModal.log.overtime_hours_2x }}</td>
					<td class="text-right">{{ transferNoticeModal.projectedLog.overtime_hours_15x.toFixed(2) }}</td>
				</tr>
				<tr v-if="transferNoticeModal.log.overtime_hours_25x > 0 || transferNoticeModal.projectedLog.overtime_hours_25x > 0">
					<th>2.5x Overtime</th>
					<td class="text-right">{{ transferNoticeModal.log.overtime_hours_25x }}</td>
					<td class="text-right">{{ transferNoticeModal.projectedLog.overtime_hours_15x.toFixed(2) }}</td>
				</tr>
				<!--<tr>
					<th>Total Hrs</th>
					<td>{{ transferNoticeModal.logTotal.toFixed(2) }}</td>
					<td>{{ transferNoticeModal.projectedLogTotal.toFixed(2) }}</td>
				</tr>-->
			</tbody>
		</table>

	</modal-dialog>

</div>
</template>

<script type="text/javascript">
import TableList from "../TableList"
import Field from "../Field"
import ModalDialog from "../ModalDialog"
import TimeLogReviewTile from "../TimeLogReviewTile"

export default {
	name: 'TimeLogReviewTable',
	components: {
		TableList,
		Field,
		ModalDialog,
		TimeLogReviewTile
	},
	props: [
		"payPeriod",
		"logs",
		"userLogsFields",
		"jobShowOverride"
	],
	data() {
		return {
			localPayPeriod: false,
			approvedLogSet: [],
			jobViewState: [],
			transferNoticeModal: {
				visible: false,
				transferRequest: {},
				log: {},
				projectedLog: {
					regular_hours: null,
					overtime_hours_15x: null,
					overtime_hours_2x: null,
					overtime_hours_25x: null
				},
				logTotal: null,
				projectedLogTotal: null,
				response: true
			},
			reviewedTilesVisible: true,
			allJobsVisible: false
		}
	},
	watch: {
		payPeriod() {
			//this.createUserList()
			this.setLocalPayPeriod()
		},
		approvedLogSet() {
			let vm = this

			let approved = true

			this.approvedLogSet.forEach(job => {
				job.forEach(user => {
					if (user == false)
						approved = false
				})

			})

			this.$emit("submitStateChange",approved)
		},
		jobShowOverride() {
			this.allJobsVisible = this.jobShowOverride
		}
	},
	methods: {
		allLogsApproved(user) {
			let allApproved = true
			user.days.forEach(day => {
				day.logs.forEach(log => {
					if (log.reviewed_by == 0) 
						allApproved = false
				})
			})

			return allApproved
		},
		jobHasMileageOrPerdiem(job) {
			let hasMileage = false
			let hasPerDiem = false

			job.users.forEach(user => {

			})
		},
		showAllJobs() {
			let vm = this

			this.allJobsVisible = true

			this.toggleJobShowState()

			//this.$emit("jobShowChange",this.allJobsVisible)
		},
		toggleJobShowState() {
			let vm = this

			this.$nextTick(() => {
				vm.$emit('jobShowChange',vm.allJobsVisible)
			})
		},
		allUserJobLogsApproved(user) {
			let allApproved = true

			user.days.forEach(day => {
				day.logs.forEach(log => {
					if (log.reviewed_by == 0)
						allApproved = false
				})
			})

			return allApproved
		},
		userLogSetReviewChanged(jobIndex,userIndex,user) {

			let batchPayload = {
				records: []
			}

			let vm = this

			let value = false
			if (this.allLogsApproved(user))
				value = 0
			else
				value = this.$store.userDetails.id

			//set all user's logs for a job to approved or not approved
			this.$nextTick(() => {
				user.days.forEach(day => {
					day.logs.forEach(log => {
						log.reviewed_by = value

						batchPayload.records.push({
							id: log.id,
							reviewed_by: log.reviewed_by
						})

					})
				})

				this.postData("TimeLog/save-batch",batchPayload,true).then(response => {
					if (response.success) {
						vm.alertSaved("Time Log review status updated")
					}
				})
			})

		},
		setVisibility(jobIndex) {
			let vm = this

			if (vm.jobViewState[jobIndex])
				vm.jobViewState[jobIndex] = false
			else
				vm.jobViewState[jobIndex] = true		
		},
		setLocalPayPeriod() {
			let jobs = []

			if (this.payPeriod && this.payPeriod.jobs) {
				jobs = this.payPeriod.jobs.map(job => {
					job.users = job.users.map(user => {
						user.showLogsList = false

						return user
					})

					return job
				})
			}

			let vm = this

			this.localPayPeriod = this.payPeriod
			this.localPayPeriod.jobs = jobs

			this.setApprovedLogSet()
		},
		setApprovedLogSet() {
			let vm = this
			this.localPayPeriod.jobs.forEach((job,jobIndex) => {
			
				let userSet = []
				job.users.forEach((user,userIndex) => {
					userSet.push(userIndex)
				})
				vm.approvedLogSet.push(userSet)
			})
		},
		toggleUserLogsPanel(user) {
			user.showLogsList = !user.showLogsList

			this.$forceUpdate()
		},
		logHasPendingTransfers(dayLog) {
			if (dayLog.PendingOvertimeTransfer.length > 0) {
				//iterate them
				let pendingFound = false
				dayLog.PendingOvertimeTransfer.forEach(transfer => {
					if (transfer.completed == 0)
						pendingFound = true
				})

				return pendingFound
			}
			else
				return false
		},
		editTimeLog(log,job) {
			if (job.reviewable) {

				if (this.logHasPendingTransfers(log))  {

					//find pending transfer
					let transfer
					log.PendingOvertimeTransfer.forEach(tran => {
						if (tran.completed == 0)
							transfer = tran
					})

					//show the pending overtime transfer instead
					this.transferNoticeModal.visible = true
					this.transferNoticeModal.transferRequest = transfer
					this.transferNoticeModal.log = log

					let totalOTHrs = parseFloat(this.transferNoticeModal.transferRequest.overtime_15x) + parseFloat(this.transferNoticeModal.transferRequest.overtime_2x) + parseFloat(this.transferNoticeModal.transferRequest.overtime_25x)

					this.transferNoticeModal.projectedLog = {
						regular_hours: parseFloat(this.transferNoticeModal.log.regular_hours) - totalOTHrs,
						overtime_hours_15x: parseFloat(this.transferNoticeModal.log.overtime_hours_15x) + parseFloat(this.transferNoticeModal.transferRequest.overtime_15x),
						overtime_hours_2x: parseFloat(this.transferNoticeModal.log.overtime_hours_2x) + parseFloat(this.transferNoticeModal.transferRequest.overtime_2x),
						overtime_hours_25x: parseFloat(this.transferNoticeModal.log.overtime_hours_25x) + parseFloat(this.transferNoticeModal.transferRequest.overtime_25x),
					}

				}
					
				else
					this.$emit('editTimeLog',log,job)
			}
			//check if all logs are reviewed now

		},
		submitTransferRequest() {
			let vm = this

			let answer = "no"
			if (this.transferNoticeModal.response)
				answer = "yes"
			
			else 
				answer = "no"
			

			this.getJSON("TimeLog/transfer-request?answer="+answer+"&token="+this.transferNoticeModal.transferRequest.token+"&response=json").then(response => {
				if (response.success) {
					vm.alertSuccess("Hours transfer completed")
					vm.transferNoticeModal.visible = false
				}
				else
					vm.alertFail(response.message)
			})


		},
		mutateUserLogs(user_id) {
			let vm = this

			let payPeriodStart = new Date(this.payPeriod.start)
			let payPeriodEnd = new Date(this.payPeriod.end)

			let filteredLogs = this.logs.filter(log => {
				let logDate = new Date(log.time_in)

				if (log.user_id == user_id && logDate >= payPeriodStart && logDate <= payPeriodEnd) 
					return true
			})

			return filteredLogs.map(log => {

				log.timeInShort = vm.formatDateTimeToLocal(log.time_in,'month-day-time')
				log.timeOutShort = vm.formatDateTimeToLocal(log.time_out,'time')

				let timeIn_ms = new Date(log.time_in)
				let timeOut_ms = new Date(log.time_out)

				let diff_ms = timeOut_ms.getTime() - timeIn_ms.getTime()

				//convert to 100th/hours
				let hoursDiff = diff_ms / 60000 / 60 * 100

				if (isNaN(hoursDiff))
					log.timeDiff = "N/A"
				else
					log.timeDiff = Math.round(hoursDiff)/100 + " hrs"

				if (log.time_out == "0000-00-00 00:00:00") 
					log.mutatedTimeOut = ""

				log.overtime_hrs = ""
				if (parseFloat(log.overtime_hours_15x) > 0)
					log.overtime_hrs += log.overtime_hours_15x + "hrs @1.5x "
				if (parseFloat(log.overtime_hours_2x) > 0)
					log.overtime_hrs += log.overtime_hours_2x + "hrs @2x "
				if (parseFloat(log.overtime_hours_25x) > 0)
					log.overtime_hrs += log.overtime_hours_25x + "hrs @2.5x "

				if (log.reviewedBy)
					log.reviewedBy = log.ReviewedBy.first_name+ " "+ log.reviewedBy.last_name
				else 
					log.reviewedBy = ""

				log.projectName = ""
				if ("Job" in log && log.Job)
					log.projectName = log.Job.job_name
				else if ("Service" in log && log.Service)
					log.projectName = log.Service.job_name

				return log
			})

			return mutatedLogs
		},
	},
	created() {
		//this.createUserList()
		let vm = this

		this.setLocalPayPeriod()
		this.allJobsVisible = this.jobShowOverride

		this.setApprovedLogSet()
	}
}
</script>

<style type="text/css" scoped>
	.row-all-approved {
		padding: 0px;
		margin-bottom: 0;
	}

	.nested-table-plain {
		width: auto;
		max-width: none;
	}

	.nested-table-plain th, .nested-table-plain td {
		padding: 2px;
		padding-left: 5px;
		padding-right: 5px;
		border: none;
	}

	.table-vertical-borders th, .table-vertical-borders td {
		border-right: 1px solid #dee2e6;
		border-left: 1px solid #dee2e6;
	}

	.table-vertical-borders th:first-child, .table-vertical-borders td:first-child {
		border-left: none;
	}

	.table-vertical-borders th:last-child, .table-vertical-borders td:last-child {
		border-right: none;
	}


</style>